<template>
	<button
		v-if="!hasAppointmentInFuture"
		class="text-functional-size-md lg:text-functional-size-lg leading-normal text-left"
	>
		<span
			v-if="remainingSlots.today > 0"
			class="text-white"
		>
			Je kunt <strong>vandaag</strong> nog terecht! We hebben nog
			<strong
				v-if="remainingSlots.today > 1"
				class="underline text-nowrap"
			>{{ remainingSlots?.today }} plaatsen</strong>
			<strong
				v-else-if="remainingSlots.today === 1"
				class="underline text-nowrap"
			>{{ remainingSlots?.today }} plaats</strong> beschikbaar.
		</span>
		<span
			v-else-if="remainingSlots.tomorrow > 0"
			class="text-white"
		>
			Je kunt <strong>morgen</strong> al terecht! We hebben nog
			<strong
				v-if="remainingSlots.tomorrow > 1"
				class="underline text-nowrap"
			>{{ remainingSlots?.tomorrow }} plaatsen</strong>
			<strong
				v-else-if="remainingSlots.tomorrow === 1"
				class="underline text-nowrap"
			>{{ remainingSlots?.tomorrow }} plaats</strong>
			beschikbaar.
		</span>
		<span
			v-else-if="remainingSlots.thisWeek > 0"
			class="text-white"
		>
			Je kunt <strong>deze week</strong> nog terecht! We hebben nog
			<strong
				v-if="remainingSlots.thisWeek > 1"
				class="underline text-nowrap"
			>{{ remainingSlots?.thisWeek }} plaatsen</strong>
			<strong
				v-else-if="remainingSlots.thisWeek === 1"
				class="underline text-nowrap"
			>{{ remainingSlots?.thisWeek }} plaats</strong>
			beschikbaar.
		</span>
		<span
			v-else-if="remainingSlots.nextWeek > 0"
			class="text-white"
		>
			Je kunt <strong>aankomende week</strong> al terecht! We hebben nog
			<strong
				v-if="remainingSlots.nextWeek > 1"
				class="underline text-nowrap"
			>{{ remainingSlots?.nextWeek }} plaatsen</strong>
			<strong
				v-else-if="remainingSlots.nextWeek === 1"
				class="underline text-nowrap"
			>{{ remainingSlots?.nextWeek }} plaats</strong>
			beschikbaar.
		</span>
		<span
			v-else-if="remainingSlots.inTwoWeeks > 0"
			class="text-white"
		>
			Je kunt <strong>in 2 weken</strong> al terecht! We hebben nog
			<strong
				v-if="remainingSlots.inTwoWeeks > 1"
				class="underline text-nowrap"
			>{{ remainingSlots?.inTwoWeeks }} plaatsen</strong>
			<strong
				v-else-if="remainingSlots.inTwoWeeks === 1"
				class="underline text-nowrap"
			>{{ remainingSlots?.inTwoWeeks }} plaats</strong>
		</span>
	</button>
</template>

<script lang="ts" setup>
const { remainingSlots, hasAppointmentInFuture } = useAppointmentPlanner();
</script>
